import React, { useContext, useEffect } from "react";
import AppContext from "../../util/AppContext";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';

import logo from "../../assets/logo_navbar.png";
import "./Navbar.css";

const drawerWidth = 240;
const navItems = [
  {
    name: 'pricing',
    route: 'pricing'
  },
  {
    name: 'careers',
    route: ''
  },
  {
    name: 'log in',
    route: 'login'
  }
]

function Navbar(props) {
  const myContext = useContext(AppContext);

  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [openDropdown, setOpenDropdown] = React.useState(true);

  const handleClickAppBar = () => {
    setOpenDropdown(!openDropdown);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const ele = document.getElementById('navbar');
    myContext.setNavbarHeight(ele.offsetHeight);
    // console.log('navbar', ele.offsetHeight)
  }, [])

  const drawer = (
    <Box onClick={handleDrawerToggle}>
      <br />
      &nbsp;&nbsp;
      <CloseIcon onClick={() => setMobileOpen(false)}/>
      <br />
      <List>
        <ListItem disablePadding>
          <ListItemButton>
            <Link to='/revirtclub#first' className="links">
              <ListItemText primary='revirt.club' className="links-name">
              </ListItemText>
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItemButton onClick={handleClickAppBar}>
          <ListItemText primary="solutions" className="links-name" />
          {openDropdown ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openDropdown} timeout="auto">
          <List component="div" disablePadding className="mobile-dropdown-drawer">
            <ListItemButton>
              <Link to='/education#first' className="links">
                <ListItemText primary="education" className="links-name dd-items" />
              </Link>
            </ListItemButton>
            <ListItemButton>
              <Link to='/office#first' className="links">
                <ListItemText primary="office" className="links-name dd-items" />
              </Link>
            </ListItemButton>
            <ListItemButton>
              <Link to='/community#first' className="links">
                <ListItemText primary="community" className="links-name dd-items" />
              </Link>
            </ListItemButton>
            <ListItemButton>
              <Link to='/event#first' className="links">
                <ListItemText primary="event" className="links-name dd-items" />
              </Link>
            </ListItemButton>
          </List>
        </Collapse>
        <ListItem disablePadding>
          <ListItemButton>
            <Link to='/pricing' className="links">
              <ListItemText primary='pricing' className="links-name" />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton>
            <Link to='/careers' className="links">
              <ListItemText primary='careers' className="links-name" />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton>
            <Link to='/login' className="links">
              <ListItemText primary='log in' className="links-name" />
            </Link>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding className="mobile-dropdown-drawer">
          <ListItemButton>
            <Link to='/signup' className="links">
              <ListItemText primary='sign up' className="links-name" />
            </Link>
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <Box sx={{ display: "flex" }} id="navbar">
        <AppBar component="nav" className="appbar">
          <Toolbar>

            {/* navbar branding */}
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: "block", sm: "block" } }}
            >
              <Link to='/' className="home-link">
                <div className="nav-branding">
                  <img src={logo} alt="" className="navbar-logo" />
                  &nbsp; &nbsp;
                  <span className="navbar-brandName">revirt.space</span>
                </div>
              </Link>
            </Typography>

            {/* hamburger menu for mobile */}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: "block", md: 'block', lg: 'none', xl: 'none' } }}
            >
              <MenuIcon />
            </IconButton>

            {/* navbar content for desktop */}
            <Box sx={{ display: { xs: "none", sm: "none", md: "none", lg: "block", xl: "block" } }}>
              <Button sx={{ marginRight: "10px" }}>
                <span className="new-tag">new</span>
                &nbsp;&nbsp;
                <Link to='/revirtclub#first' style={{
                  textDecoration: 'none'
                }}>
                  <span className="navbar-links">revirt.club</span>
                </Link>
              </Button>
              <Button
                sx={{ marginRight: "10px" }}
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                onMouseOver={handleClick}
              >
                <span className="navbar-links">solutions</span>
                &nbsp;
                <span style={{ color: "#fff" }}>▼</span>
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                  onMouseLeave: handleClose
                }}
                className="navbar-dropdown"
              >
                <MenuItem
                  onClick={handleClose}
                  className="navbar-dropdown-items"
                >
                  <Link to='/education#first' style={{
                    textDecoration: 'none'
                  }}>
                    education
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleClose}
                  className="navbar-dropdown-items"
                >
                  <Link to='/office#first' style={{
                    textDecoration: 'none'
                  }}>
                    office
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleClose}
                  className="navbar-dropdown-items"
                >
                  <Link to='/community#first' style={{
                    textDecoration: 'none'
                  }}>
                    community
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleClose}
                  className="navbar-dropdown-items"
                >
                  <Link to='/event#first' style={{
                    textDecoration: 'none',
                  }}>
                    event
                  </Link>
                </MenuItem>
              </Menu>
              {navItems.map((item) => (
                <Button key={item.name} sx={{ marginRight: "10px" }}>
                  <Link to={`/${item.route}`} className='links'>
                    <span className="navbar-links">{item.name}</span>
                  </Link>
                </Button>
              ))}
              <Button
                sx={{
                  background: "rgba(255, 255, 255, 0.4)",
                  borderRadius: "16px",
                  padding: "8px 15px",
                }}
              >
                <span className="navbar-links">sign up</span>
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
        <Box component="nav">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none", md: "none", lg: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: '#000',
                color: '#fff',
              },
            }}
            anchor="right"
          >
            {drawer}
          </Drawer>
          <Toolbar />
        </Box>
      </Box>
    </>
  );
}

Navbar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default Navbar;
